var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReply = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "10 10 10 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14.998 12.09v-1.466c0-.62-.373-.812-.824-.422l-4.004 3.445a.45.45 0 0 0 0 .705l4.006 3.446c.449.388.822.198.822-.423V16h1c1.757.317 2.817 1.887 3.475 3.532.103.257.253.257.325-.01.129-.486.2-.996.2-1.522a5.996 5.996 0 0 0-5-5.91"
})));
export default SvgReply;